module.exports = __webpack_public_path__ + "static/media/photo10.d5d8bd44.jpg";